<template>
  <div class="d-flex">
    <button v-bind="attributesBinding" v-if="currentField.isType != 'TEXT'" />
    <h4
      v-bind="attributesBinding"
      class="text-center px-2"
      v-else
      :class="currentField.isType == 'CIRCLE' ? ' rounded-circle' : null"
    >
      {{ currentField.value ? currentField.value : currentField.text }}
    </h4>
  </div>
</template>


<script>
export default {
  name: "Label",
  store: ["mainExpression"],
  props: ["currentField"],
  computed: {
    attributesBinding() {
      var attr = {};
      const { currentField } = this;
      if (currentField.id) {
        attr.id = `label-${currentField.id}`;
      }
      if (currentField.color) {
        attr.style = {
          color: currentField.isType == "TEXT" ? currentField.color : "white",
        };
      }
      if (currentField.isType != "TEXT") {
        attr.style = { border: `2px solid ${currentField.color}` };
      }
      return attr;
    },
  },
};
</script>
<style scoped>
::v-deep .v-input__slot {
  min-height: 30px !important;
}
h4 {
  user-select: none;
}
button {
  height: 26px;
  background-color: white;
  width: 80px;
  border-radius: 4px;
}
button:focus {
  outline: none;
}
</style>
